module.exports = __webpack_public_path__ + "img/b5efb3787d2aea7d84a8b43c28a58ab.c9a6c023.png";